import type { RefundInvoice } from '~/api/graphql/generated/types'

export const calculateRefundableAmount = (invoice: RefundInvoice): number =>
  (invoice.amount || 0) - (invoice.paidAmountNoFee || 0)

export const isPartialRefund = (
  refundAmount: number,
  invoice: RefundInvoice,
): boolean => {
  const refundableAmount = calculateRefundableAmount(invoice)
  return refundAmount > 0 && refundAmount < refundableAmount
}
